import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader, AdminDashboard, StandardSkeleton } from '@municipality/ui';

const Dashboard: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const isLoading = false; // TODO: Replace with actual loading state if available

  return (
    <div style={{ padding: '24px' }}>
      <PageHeader
        title={t('title', 'Dashboard')}
        subtitle={t('subtitle', 'Platform overview and statistics')}
      />
      <StandardSkeleton loading={isLoading} rows={6}>
        <AdminDashboard />
      </StandardSkeleton>
    </div>
  );
};

export default Dashboard; 